import React, { useState, useRef, useEffect } from 'react';
import cn from 'classnames';

import styles from './Image.module.css';

const getRandomNumber = (min, max) => Math.floor(Math.random() * (max - min + 1) + min);

const Image = ({ item }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const imageRef = useRef(null);
  const delay = useRef(getRandomNumber(1, 5));

  useEffect(() => {
    if (imageRef.current && imageRef.current.complete) {
      handleImageLoaded();
    }
  }, []);

  const handleImageLoaded = () => {
    setImageLoaded(true);
  };

  return (
    <>
      <img
        className={cn('absolute inset-0 w-full h-full object-cover', styles.image, {
          [`${styles.animate}`]: imageLoaded
        })}
        src={item.img.src}
        ref={imageRef}
        onLoad={() => handleImageLoaded()}
        alt={item.img.alt}
        style={{ transitionDelay: `${delay.current * 100}ms` }}
      />
      <img
        className={cn('absolute inset-0 w-full h-full object-cover', styles.svg, {
          [`${styles.animate}`]: imageLoaded
        })}
        src={item.svg.src}
        alt={item.svg.alt}
      />
    </>
  );
};

export default Image;
